
import Modal from '@mui/material/Modal';
import "../App.css"

function NavbarModal ({ openModal, defaultProjectId, setOpenModal }) {
    return (
        <Modal
            open={openModal.open}
            onClose={() => setOpenModal({open: false, modalType: ""})}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="page"
        >
            <div className="page question-modal">
                <h1 className="questions-modal-title">{openModal.modalType}</h1>
                    <div className="inner-question-container">
                        <p className="question">What is Descope Explorer?</p>
                        <p>Descope Explorer is an easy way to demo your own project authentication flows.</p>
                        <p className="question">How can I add my own project id, flow id, style id, and theme?</p>
                        <p>1. Add it to the URL and format it like this: <br /> <br /><span className="question-ans-break">https://explorer.descope.com/?project={defaultProjectId}&flow=otp-over-sms&theme=dark&style=new-style</span></p>
                        <p className="question">OR</p>
                        <p>2. Click on the settings icon on the top right navbar to modify all the parameters through input fields.</p>
                    </div>

            </div>
        </Modal>
    )
}


export default NavbarModal